import AppColors from 'general/constants/AppColors';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';

CustomCard.propTypes = {
  titleIcon: PropTypes.string,
  imgIcon: PropTypes.string,
  titleText: PropTypes.string,
  body: PropTypes.element,
  fullHeight: PropTypes.bool,
  additionalClassName: PropTypes.string,
  showHeader: PropTypes.bool,
  showBorder: PropTypes.bool,
  refHeader: PropTypes.any,
  subTitleText: PropTypes.string,
  showBorderTitle: PropTypes.bool,
  bgTransparent: PropTypes.bool,
  onClick: PropTypes.func,
};

CustomCard.defaultProps = {
  titleIcon: null,
  imgIcon: null,
  titleText: '',
  body: <></>,
  fullHeight: true,
  additionalClassName: '',
  showHeader: true,
  showBorder: true,
  showBorderTitle: true,
  bgTransparent: false,
  onClick: () => {},
};

function CustomCard(props) {
  // ---- params ----
  const {
    titleIcon,
    imgIcon,
    titleText,
    body,
    fullHeight,
    additionalClassName,
    showHeader,
    showBorder,
    refHeader,
    subTitleText,
    showBorderTitle,
    bgTransparent,
    onClick,
  } = props;

  return (
    <div
      className={`${additionalClassName} ${!bgTransparent ? 'bg-white' : ''} ${
        fullHeight ? 'h-100' : ''
      }`}
      style={{
        border: showBorder ? `1px solid ${AppColors.gray[300]}` : '',
      }}
      onClick={onClick}
    >
      {/* title */}
      {showHeader && (
        <div
          className="d-flex flex-row align-items-center"
          style={{
            borderBottom: showBorderTitle ? `1px solid ${AppColors.gray[300]}` : '',
            padding: '10px',
          }}
          ref={refHeader}
        >
          {titleIcon && (
            <i className={`${titleIcon} mr-2`} style={{ color: AppColors.gray[800] }} />
          )}
          {imgIcon && <img src={imgIcon} />}
          <div className="d-flex flex-column ml-2">
            <span
              style={{
                fontWeight: '600',
                color: AppColors.gray[800],
                fontSize: Utils.convertToFontSize(16),
              }}
            >
              {titleText}
            </span>
            <span
              style={{
                fontWeight: '600',
                color: AppColors.gray[700],
                fontSize: Utils.convertToFontSize(13),
              }}
            >
              {subTitleText}
            </span>
          </div>
        </div>
      )}

      <div className={`${!bgTransparent ? 'bg-white' : ''} h-100`}>{body}</div>
    </div>
  );
}

export default CustomCard;
